const selectors: Record<"block", string> = {
  block: "[data-kasteel-form]",
};

const init = () => {
  const blocks = Array.from(document.querySelectorAll(selectors.block)) || [];

  if (blocks.length === 0) return;

  blocks.forEach((block) => {
    const buttonContainer = block.querySelector('input[type="submit"]');

    if (buttonContainer) {
      buttonContainer.insertAdjacentHTML(
        "afterend",
        '<div class="kasteel-form-button-icon"></div>'
      );
    }
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    init();
  },
  {
    once: true,
  }
);
